import React, { Component } from 'react';
import DomTemplate from '../mainpage/domTemplate';
import _ from 'lodash';
import shortid from 'shortid';
import $ from 'jquery';
import commonStore from '../store/commonStore.js';
import * as HTML_RENDITION from '../utils/general/general';
import { DropdownButton, Dropdown, Carousel } from 'react-bootstrap';
import { RSCH_HTML_TRACKING_CONFIG } from '../readership/trackingConfig';
import ReactDOM from 'react-dom';
import { forceCheck } from 'react-lazyload';
import {isDeviceScreenType} from '../utils/general/deviceInfoService';
import FigureGallerySlide from './figureGallerySlide';
import Ellipsis from '../utils/general/Ellipsis';
import {RenditionLoadable} from '../utils/general/LoadableRelated';

const productType = window.HTML_RENDITION.initialData.productType;
const themeFromURL = "";
// _.get(
//     _.get(_.get(window, "location.href", "").split("?"), "[1]", "").split("="),
//       "[1]",
//       ""
// );
const showOldBranding = themeFromURL === "" ? (_.includes(["globalinsights","gps"],productType) ||
    window.HTML_RENDITION.initialData.enable2023rebranding === 'false') : themeFromURL === "old" ? true : false;

interface IFigureGalleryDomProps {
    targetName: string;
}

interface IFigureGalleryDomStatus {
    displayLeftNav: object;
    index: number;
    expanded: boolean;
}

export class FigureGalleryDom extends Component<IFigureGalleryDomProps, IFigureGalleryDomStatus> {

    public resultTemplate: any;
    public galleryDropdown: any;
    public leftNavRef: any;
    public fData: any;
    public openFGFlg = true;
    public figureGalleryDataTextCopy = [];
    public openedSelected = -1;
    public fgSlides = [];
    public leftNavDom = [];
    public mobileViewDropdownItem = [] as any;
    public slideFirstRenderFlg = false;
    public triggeredByClickNav = true;
    public selectedNavItemTop = 0;
    public isHTMLEditorType = window.HTML_RENDITION.initialData.docFileType;

    constructor(props: IFigureGalleryDomProps) {
        super(props);
        this.resultTemplate = null;
        this.leftNavRef = React.createRef();
        this.state = {
            displayLeftNav: { position: 'absolute', right: '2000px' },
            expanded: false,
            index: 0
        };
        const _figureGalleryData = commonStore.getState().asyncStateReducer.figureGalleryData;
        const _fpFigureGalleryData = commonStore.getState().asyncStateReducer.FPfigureGalleryData;
        if (!_.isEmpty(_figureGalleryData)) {
            this.fData = _figureGalleryData;
        } else if (!_.isEmpty(_fpFigureGalleryData)) {
            this.fData = _fpFigureGalleryData;
        }
    }

    public componentDidMount() {
        isDeviceScreenType() && setTimeout(forceCheck, 500);
        if (this.openedSelected != -1 && this.slideFirstRenderFlg) {
            this.handleSelect(this.openedSelected);
            this.openedSelected = -1;
            this.slideFirstRenderFlg = false;
        }
        this.handleDOMAttributes();
    }

    public componentDidUpdate(){
        if (!_.has(this.state.displayLeftNav, 'display')) {
            $(this.leftNavRef.current).find('li.nav_selected').focus();
            this.navPaneScrollbarBehavior(this.triggeredByClickNav);
        }
    }

    public addStyleToSelectedNavItem () {
        // add selected class to nav item
        const index = $('ol.fg.carousel-indicators').find('.active').index();
        $('#left-nav').find('.nav_selected').removeClass('nav_selected');
        $('#left-nav .fg-nav-item').eq(index).addClass('nav_selected');
    }

    public handleDOMAttributes () {
        setTimeout(() => {
            this.addStyleToSelectedNavItem();
            // ADA C150113-52977
            $('.fg .carousel-control-prev:visible').attr('tabindex', '0');
            $('.fg .carousel-control-next:visible').attr('tabindex', '0');
            $('.fg .carousel-control-prev:visible').attr('aria-label', 'Previous');
            $('.fg .carousel-control-next:visible').attr('aria-label', 'Next');
        }, 500);
    }

    public galleryScrollTo() {
        if (
            window.HTML_RENDITION.initialData.productType === 'blog' &&
            !HTML_RENDITION.isStaticHtmlMode() &&
            !HTML_RENDITION.isPreview()
        ) {
            return;
        }

        const selectedFigure = $('#right-pane .fg.carousel-item.active div');
        const location: any = selectedFigure.attr("data-name");
        if ($('#' + location).length) {
            HTML_RENDITION.bodyScrollTo(location);
        } else if ($('.' + location).length && this.isHTMLEditorType) {
            HTML_RENDITION.bodyScrollToByClassName(location);
        }
         else {
            console.error('unable to find figure reference link. ID: ' + location);
        }
        RSCH_HTML_TRACKING_CONFIG.trackGalleryScrollTo(location);
    }

    public findPage(e: any) {
        e.preventDefault();
        this.findPageInternal(e);
        this.triggeredByClickNav = true;
        this.selectedNavItemTop = $('#left-nav').scrollTop() || 0;
    }

    public findPageInternal(e: any){
        RSCH_HTML_TRACKING_CONFIG.trackFigureGalleryInBodyClick();
        let index = 0;
        if (isDeviceScreenType()) {
            index = $(e.target).parents('.galleryDropDownItem').index();
            $('#left-nav').find('.nav_selected').removeClass('nav_selected');
            $('#left-nav .fg-nav-item').eq(index).addClass('nav_selected');
        } else {
            $(e.target).parents('#left-nav').find('.fg-nav-item').removeClass('nav_selected');
            $(e.target).parents('.fg-nav-item').addClass('nav_selected');
            index = $(e.target).parents('#left-nav').find('.nav_selected').index();
        }

        $('ol.fg.carousel-indicators').find('li').eq(index).click();
        this.galleryDropdown = $('#galleryDropdown');
        const targetText = $("#left-nav>li").eq(index).find('.paragraph-with-content').text();
        this.galleryDropdown.text(targetText);
        isDeviceScreenType() && setTimeout(forceCheck, 500);
    }

    public navPaneScrollbarBehavior (shouldKeepPositionFlag: boolean) {
        let diff = 0;
        if (shouldKeepPositionFlag) {
            diff = this.selectedNavItemTop;
        } else {
            const navPaneTop = document.getElementById('left-nav')?.getBoundingClientRect().top || 0;
            const selectedItemTop = document.getElementsByClassName('nav_selected')[0]?.getBoundingClientRect().top || 0;
            diff = selectedItemTop - navPaneTop;
        }
        $('#left-nav').scrollTop(diff);
    }

    public enterPressed(e: any) {
        const code = e.keyCode || e.which;
        if (code === 13 || code === 32) {
            this.findPageInternal(e);
        }
    }

    public collapseLeftPane() {
        if (_.isEmpty(this.state.displayLeftNav)) {
            RSCH_HTML_TRACKING_CONFIG.trackFigureGalleryExpand();
            this.setState({
                displayLeftNav: { display: 'none' },
                expanded: false
            });
        } else {
            RSCH_HTML_TRACKING_CONFIG.trackFigureGalleryCollapse();
            this.triggeredByClickNav = false;
            this.setState({
                displayLeftNav: {},
                expanded: true
            });
        }
    }

    public enterPressedCollapse(event: any) {
        const key = event.keyCode || event.which;
        if (key === 13 || key === 32) {
            this.collapseLeftPane();
        }
    }

    public handleToolTipShow(e: any, fgItemTooltip: any) {
        if (!document.getElementById('fg-tooltip') && fgItemTooltip) {
            const currentTargetRect = e.currentTarget.getBoundingClientRect();
            const event_offsetX = currentTargetRect.right;
            const event_offsetY = currentTargetRect.top;
            const newdiv = document.createElement('div');
            const att = document.createAttribute("id");
            att.value = "fg-tooltip";
            newdiv.style.left = event_offsetX + 10 + 'px';
            newdiv.style.top = event_offsetY - 5 + 'px';
            newdiv.setAttributeNode(att);
            document.body.appendChild(newdiv);

            const fgToolTipContainer = [];
            const container =
                (
                    <div className="fgToolTipecontainer">
                        {fgItemTooltip}
                    </div>
                );
            fgToolTipContainer.push(container);
            ReactDOM.render(fgToolTipContainer, document.getElementById('fg-tooltip'));
        }

    }

    public handleToolTipHide(e: any, fgItemTooltip: any) {
        if (document.getElementById('fg-tooltip') && fgItemTooltip) {
            const el: any = document.getElementById('fg-tooltip');
            document.body.removeChild(el);
        }
    }

    public renderClickHere() {
        const _i18n = commonStore.getState().asyncStateReducer.docHeaderJsonData.i18n;
        return (<span className="figure_gallery_click_here_link">
                    {_i18n.figure_here_before + ' '}
                    <a tabIndex={0} role="button" aria-label="scroll to" id="figureGalleryScrollTo" style={{ cursor: 'pointer' }}
                        onClick={() => this.galleryScrollTo()}
                        onKeyPress={(e) => this.enterPressedToggleScrollCloseModal(e)}>
                        {_i18n.figure_here}
                    </a>
                    {' ' + _i18n.figure_here_after}
                </span>);
    }

    public enterPressedToggleScrollCloseModal(event: any) {
        const key = event.keyCode || event.which;
        if (key === 13 || key === 32) {
            $('#modalClose').click();
            this.galleryScrollTo();
        }
    }

    public renderLeftNavigation () {
        const data = this.fData;
        const captionsTpl: any = [];
        const dropDownItems: any = [];
        if (this.leftNavDom.length > 0) {
            return this.leftNavDom;
        }
        (data.figureGallery || data).forEach((figure: any, idx: number) => {
            const leftNavTitle = !_.isUndefined(figure.leftNavCaption) ? figure.leftNavCaption : figure.caption;
            const fgItemText = figure.leftNavCaption?.data[0]?.data[0]?.text;
            const fgItemTooltip = figure.leftNavCaption?.data[0]?.data[0]?.tooltip;
            const fgItemDesc = figure.leftNavCaption?.data[1]?.data[0].text;

            const fgItemHeaderTpl = `${(fgItemText ? fgItemText.trim() : '')}`;
            let fgIndentClass:string = '';
            // for old FAVE's HTML template's FG, figure title in LHS is like 'Figure 1.', we need to indent it rather than just number
            _.startsWith(fgItemHeaderTpl.toLowerCase(), 'figure') ? fgIndentClass = 'indentFig' : fgIndentClass = 'indentNum';

            // left pane
            const figureGalleryNum = data.figureGallery.length;
            if (figureGalleryNum > 0 && !(_.isEmpty(figure.images) && _.isEmpty(figure.table) && _.isEmpty(figure.text))) {
                captionsTpl.push(
                    <li className="fg-nav-item" key={idx} style={{ overflow: 'hidden', position: 'relative' }}>
                        <span className="title-icon">&#187;</span>
                        <div className={`x-rsch-run control-font ${figure.isInfographic ? 'infographic-img' : ''}`} onClick={(e) => this.findPage(e)} onKeyPress={(e: any) => this.enterPressed(e)} tabIndex={0} role="button">
                            {<p className={"x-rsch-paragraph CIRCaption paragraph-with-content " + fgIndentClass}>
                                <span className="x-rsch-run CIRCaption CIRCaptionHeader"
                                        onMouseEnter={(e) => this.handleToolTipShow(e, fgItemTooltip)}
                                        onMouseLeave={(e) => this.handleToolTipHide(e, fgItemTooltip)}
                                >
                                    <Ellipsis line={2} timeout={true}>{fgItemHeaderTpl}</Ellipsis>
                                </span>
                            </p>}
                            {fgItemDesc && <p className={"x-rsch-paragraph CIRSubCaption paragraph-with-content " + fgIndentClass}>
                                {
                                    this.isHTMLEditorType ?
                                    <span className="x-rsch-run CIRSubCaption  CIRCaptionDesc" ><Ellipsis line={2} timeout={true}>{fgItemDesc}</Ellipsis></span> :
                                    <span className="x-rsch-run CIRSubCaption  CIRCaptionDesc" >{fgItemDesc}</span>
                                }
                            </p>}
                        </div>
                    </li>
                );
                this.leftNavDom = captionsTpl;
                // dropdownlist for mobile view
                dropDownItems.push(
                        <Dropdown.Item eventKey={idx} key={idx} className='galleryDropDownItem ellipsis' onClick={(e: any) => {this.findPage(e);}}>
                            <DomTemplate sourceM={leftNavTitle} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />
                        </Dropdown.Item>);
                this.mobileViewDropdownItem = dropDownItems;
            }

        });

        setTimeout(() => {  // for the first time opened slide's dropdown title
            this.galleryDropdown = $('#galleryDropdown');
            const targetText = $("#left-nav>li").eq(0).find('.paragraph-with-content').text();
            this.galleryDropdown.text(targetText);
        }, 100);

        return this.leftNavDom;
    }

    public isInfogrpahics(obj: any) {
        return (obj.contentWindow?.INFOGRAPHIC === undefined);
    }

    public setInfoIframeSize(obj: any) {
        try {
            const iframe: any = $(obj);
            if (!this.isInfogrpahics(obj)) {
                const iframeScale = Math.ceil(obj.contentWindow.INFOGRAPHIC.scale * 10) / 10;
                if (iframe && iframe.contents().find('div').eq(0) && iframe.contents().find('div').eq(0).height()) {
                    iframe.height(Math.ceil(iframe.contents().find('div').eq(0).height() * iframeScale));
                }
                return;
            }

            const infographicHeight : number = iframe.contents().find("html").height();
            if (infographicHeight == 0) {
                // Set a min height 800
                iframe.height(800);
            } else {
                iframe.height(infographicHeight);
            }
        } catch (e) {
            console.log(e);
        }
    }

    public handleSelect (selectedIndex: any, eventKey?: any, event?: any) {    // for the other dropdown title
        this.setState({
            index: selectedIndex
        });
        setTimeout(() => {
            const targetNav = $("#left-nav>li").eq(selectedIndex);
            const targetText = targetNav.find('.paragraph-with-content').text();
            isDeviceScreenType() && forceCheck();
            this.galleryDropdown.text(targetText);
            this.addStyleToSelectedNavItem();
            if (targetNav.find('.infographic-img').length > 0) {
                const infographicObj = $('.fg.carousel-item').eq(selectedIndex).find('iframe')[0];
                this.setInfoIframeSize(infographicObj);
            }
            if (event?.target?.classList?.contains('gallary-title')) {
                $('.fg.carousel-item').eq(selectedIndex).find('.gallary-title').focus();
            }
        }, 100);
    }

    public checkOpenedFGSequence (figure: any) {
        const targetName = this.props.targetName || '';
        if (_.isEmpty(targetName)) {
            return false;
        }
        const figureString = JSON.stringify(figure);
        const reg = new RegExp(`${targetName}\"`, 'gim');
        const res = figureString.match(reg);
        const count = !res ? 0 : res.length;

        return count > 0;
    }

    public renderSlides() {
        const data = this.fData;
        if (_.isEmpty(data)) {
            return null;
        }

        if (this.fgSlides.length > 0) {
            return this.fgSlides;
        }

        const temp: any = [];

        (data.figureGallery || data).forEach((figure: any, arrayIndex: number) => {
            // right pane
            if (_.isEmpty(figure.images) && _.isEmpty(figure.table) && _.isEmpty(figure.text)) {
                return;
            }
            // Only opening FG to get the first rendered slide can enter this if block.
            if (this.openFGFlg && this.checkOpenedFGSequence(figure)) {
                this.openFGFlg = false;
                this.openedSelected = temp.length;
            }
            temp.push(
                <Carousel.Item key={temp.length}>
                    <FigureGallerySlide figure={figure} arrayIndex={arrayIndex} idx={temp.length} />
                </Carousel.Item>
            );

            this.fgSlides = temp;
        });

        return this.fgSlides;
    }

    public loadBranding() {
        let Branding: any;
    
        if (showOldBranding) {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/figureGalleryOld'),
          }, "figureGalleryOld", Date.now());
        }
        else {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/figureGalleryNew'),
          }, "figureGalleryNew", Date.now());
        }
    
        return <Branding/>;
      }

    public render () {
        const temp = this.renderSlides();
        if (_.isEmpty(temp)) {
            return null;
        }

        let OpenedSelectedSlide = -1;
        if (this.openedSelected != -1 && !this.slideFirstRenderFlg) {
            OpenedSelectedSlide = this.openedSelected;
            this.slideFirstRenderFlg = true;
        }

        const leftNav = this.renderLeftNavigation();
        const mobileViewDropdown = this.mobileViewDropdownItem;

        return (
            <React.Fragment>
                <div id="figure_gallery" style={{ height: '100%', display: 'flex' }}>
                    {this.loadBranding()}
                    <ol id="left-nav" ref={this.leftNavRef} style={this.state.displayLeftNav} hidden={!this.state.expanded}>
                        {leftNav}
                    </ol>
                    <div id="right-pane" style={{ width: '100%'}} className="infiniteCarousel">
                        <div tabIndex={0} id="fg_slider" role="button" aria-label="List of Figures"
                                    aria-expanded={this.state.expanded} className='fg_collapsed'
                                    onKeyPress={(e: any) => this.enterPressedCollapse(e)}
                                    onClick={() => this.collapseLeftPane()}></div>
                        <div id="dropdown-sort">
                            <DropdownButton id='galleryDropdown' className="cv_mb_dropdown rendition_dropdown company-dropdown" title={''}>
                                {mobileViewDropdown}
                            </DropdownButton>
                        </div>
                        <div style={{clear: 'both'}}></div>
                        <Carousel
                            interval={0}
                            bsPrefix={'fg carousel'}
                            indicators={true}
                            controls={(temp!.length > 1)}
                            onSelect={this.handleSelect.bind(this)}
                            activeIndex={OpenedSelectedSlide != -1 ? OpenedSelectedSlide : this.state.index}
                        >
                            {temp}
                        </Carousel>
                        {this.renderClickHere()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default FigureGalleryDom;
